/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TransactionRefund } from './TransactionRefund';
import {
    TransactionRefundFromJSON,
    TransactionRefundFromJSONTyped,
    TransactionRefundToJSON,
} from './TransactionRefund';

/**
 * 
 * @export
 * @interface RefundMoneyInOutput
 */
export interface RefundMoneyInOutput {
    /**
     * 
     * @type {TransactionRefund}
     * @memberof RefundMoneyInOutput
     */
    transaction?: TransactionRefund;
    /**
     * 
     * @type {Error}
     * @memberof RefundMoneyInOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the RefundMoneyInOutput interface.
 */
export function instanceOfRefundMoneyInOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RefundMoneyInOutputFromJSON(json: any): RefundMoneyInOutput {
    return RefundMoneyInOutputFromJSONTyped(json, false);
}

export function RefundMoneyInOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefundMoneyInOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transaction': !exists(json, 'transaction') ? undefined : TransactionRefundFromJSON(json['transaction']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function RefundMoneyInOutputToJSON(value?: RefundMoneyInOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transaction': TransactionRefundToJSON(value.transaction),
        'error': value.error,
    };
}

